<template>
  <div class="contactUs">
    <section class="main_section">
    <div class="page-contentbox">
      <a @click="goBack" class="back-link">
        <i class="material-icons">arrow_back_ios</i> Back
      </a>
      <h2>Contact Us</h2>
      <p>
        <b>Rovi91 Innovations Pvt Ltd</b>
      </p>
      <p>Address - 311, Mamram East Plaza, Plot No 192, Sector G, Mayur Vihar, Phase 3, Delhi - 110096</p>
      <p>
        Email Id -
        <a href="mailto:help@mall91.com">help@mall91.com</a>
      </p>
      <p>
        Phone Number -
        <a href="tel:011-43092005">011-43092005</a>
      </p>
    </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA"
    };
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
